import { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { getDefaultAuthenticatedPath } from "@/utils/permissions";

export default function PublicLayout() {
	const { user, loading } = useAuth();
	const navigate = useNavigate();
	const [shouldRedirect, setShouldRedirect] = useState(false);

	useEffect(() => {
		if (!loading && user) {
			setShouldRedirect(true);
			navigate(getDefaultAuthenticatedPath(user.role), { replace: true });
		}
	}, [loading, user, navigate]);

	// Se está carregando, mostra loading mas ainda renderiza children para evitar bloqueio
	if (loading && !user) {
		return (
			<div className="flex h-screen items-center justify-center">
				<div className="flex flex-col items-center gap-4">
					<div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
					<p className="text-lg text-primary">Carregando...</p>
				</div>
			</div>
		);
	}

	// Se está redirecionando, mostra loading
	if (shouldRedirect || user) {
		return (
			<div className="flex h-screen items-center justify-center">
				<div className="flex flex-col items-center gap-4">
					<div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent" />
					<p className="text-lg text-primary">Redirecionando...</p>
				</div>
			</div>
		);
	}

	return (
		<div>
			<Outlet />
		</div>
	);
}
